import contentPicker from '../../templates/02-components/content-picker/analytics.content-picker';
import cardBrowser from '../../templates/02-components/card-browser/analytics.card-browser';
import featureCardA from '../../templates/02-components/feature-card-a/analytics.feature-card-a';
import iconStrip from '../../templates/02-components/icon-strip/analytics.icon-strip';
import imageCardA from '../../templates/02-components/image-card-a/analytics.image-card-a';
import pagination from '../../templates/02-components/pagination/analytics.pagination';
import xlHero from '../../templates/02-components/xl-hero/analytics.xl-hero';

function init() {
  contentPicker();
  cardBrowser();
  featureCardA();
  iconStrip();
  imageCardA();
  pagination();
  xlHero();
}

export default init;
